import React from 'react';
import './Button.scss';
import sprite from '../../../static/sprite.svg';

const Button = ({
  type,
  buttonStyle = 'PRIMARY',
  label,
  onClick,
  center = false,
}) => {
  const buttonClass =
    buttonStyle === 'PRIMARY' ? 'btn--primary' : 'btn--secondary';
  const centerClass = center ? 'btn--center' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      className={`btn ${buttonClass} ${centerClass}`}
    >
      <span className="btn__text">{label}</span>
      <span className="btn__icon-box">
        <svg className="btn__icon">
          <use href={`${sprite}#right-arrow`} />
        </svg>
      </span>
    </button>
  );
};

export default Button;
